import React from 'react'
import PhotoContextMenu from './PhotoContextMenu'
import PhotoSelectionBar from './PhotoSelectionBar'
import { usePhotoBulkActions, PhotoBulkActionsOptions } from './usePhotoBulkActions'

interface Props extends PhotoBulkActionsOptions {
  menuAt: { x: number; y: number } | null
  onMenuClose: () => void
}

/** Everything a selection brings: the bar in the toolbar's place, the right-click menu and their dialogs. */
const PhotoSelection: React.FC<Props> = ({ menuAt, onMenuClose, ...options }) => {
  const { actions, loading, dialogs } = usePhotoBulkActions(options)
  return (
    <>
      <PhotoSelectionBar count={options.selectedIds.length} actions={actions} loading={loading} onClear={options.onClear} />
      <PhotoContextMenu at={menuAt} actions={actions} onClose={onMenuClose} />
      {dialogs}
    </>
  )
}

export default PhotoSelection
